module.exports = __webpack_public_path__ + "static/drillt_frau_waller_welt_2.2ec7882d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/drillt_frau_waller_welt_2.jpg
// module id = 1132
// module chunks = 35783957827783